import {MutationTree} from "vuex";
import * as moment from "moment";

export const mutations: MutationTree<any> = {

    setClusterStats(state: any, payload: any) {
        state.clusterStatsExpire = moment().add(4, 'hours');
        state.clusterStats = Object.assign({}, state.chartData, payload.data);
    },
};
